import { observer } from 'mobx-react-lite'
import { useArticle } from '../../../hooks/queries/articles/useArticle'
import { Card } from '../../DocRightRail/screens/AIAssistant/Card'
import Styles from '../../DocRightRail/screens/AIAssistant/AIAssistant.module.scss'
import { SingleAssigneePropertiesContainer } from '../../SingleAssigneePropertiesContainer/SingleAssigneePropertiesContainer'
import { AssigneeType } from '../../../api/clients/PropertyClient'
import { DocInfoContainer } from '../../DocInfoContainer/DocInfoContainer'
import { cloneElement, ReactElement, useState } from 'react'
import { mergeProps } from '@react-aria/utils'
import cx from 'classnames'
import { OptionSelectVariant } from 'common/OptionSelect/OptionSelect'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  articleKey: string
}

interface InfoSectionProps {
  title: string
  children: ReactElement | null | undefined
  className?: string
}

export const InfoSection = ({ title, children, className }: InfoSectionProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const [showSection, setShowSection] = useState(true)

  return (
    <Card className={cx(className, { [Styles.hidden]: !showSection })}>
      {isSystemRedesignEnabled ? (
        <div className={Styles.sectionTitle}>
          <Text variant="secondary">{title}</Text>
        </div>
      ) : (
        <span className={Styles.title}>{title}</span>
      )}
      {children && cloneElement(children, { ...mergeProps(children.props, { setShowSection }) })}
    </Card>
  )
}

export const BlazeInfo = observer(({ articleKey }: Props) => {
  const { data } = useArticle(articleKey)
  const article = data?.article

  return (
    <>
      <InfoSection title="Properties" className={Styles.properties}>
        {article && (
          <SingleAssigneePropertiesContainer
            variant={OptionSelectVariant.Filter}
            assignee={{ id: article.id, type: AssigneeType.Article }}
            workspaceId={article.company.key}
            showEducationTooltip
            setShowSection={() => {}}
            className={Styles.propertiesList}
          />
        )}
      </InfoSection>
      <InfoSection title="Doc info">
        {article && (
          <DocInfoContainer
            className={Styles.propertiesList}
            assignee={{ id: articleKey, type: AssigneeType.Article }}
          />
        )}
      </InfoSection>
    </>
  )
})
